import React, { useState } from "react";
import { Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

function MyComponent({ onClick, onClickCart, disabled }) {
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const token = loginData?.token;
  const [showCheckout, setShowCheckout] = useState(false);

  const navigate = useNavigate();

  const handleButtonClick = () => {
    setShowCheckout(true);
  };

  const handleCheckoutClick = () => {
    token ? navigate("/checkout") : navigate("/fillForm");
  };

  return (
    <Box>
      {/* Main Button */}

      {showCheckout ? (
        <Button
        disabled={disabled}
          onClick={onClickCart}
          sx={{
            backgroundColor: "#FF7900",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            padding: "10px 20px",
            fontSize: "15px",
            fontWeight: "bold",
            textTransform: "capitalize",
            width: "100%",
            "&:hover": {
              backgroundColor: disabled ? "#ccc" : "#e65500",
              color: "#fff",
            },
          }}
        >
          Add to cart
        </Button>
      ) : (
        <Button
        disabled={disabled}
          onClick={handleButtonClick}
          sx={{
            backgroundColor: "#FF7900",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            padding: "10px 20px",
            fontSize: "15px",
            fontWeight: "bold",
            textTransform: "capitalize",
            width: "100%",
            "&:hover": {
              backgroundColor: disabled ? '#ccc' :  "#e65500",
              color: "#fff",
            },
          }}
        >
          Confirm Booking
        </Button>
      )}

      {/* Conditional rendering of Checkout Button */}
      {showCheckout && (
        <Button
        disabled={disabled}
          onClick={onClick}
          sx={{
            backgroundColor: "#4CAF50",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            padding: "10px 20px",
            fontSize: "15px",
            fontWeight: "bold",
            textTransform: "capitalize",
            marginTop: "20px",
            width: "100%",
            "&:hover": {
              backgroundColor: disabled ? "#ccc" : "#45a049",
              color: "#fff",
            },
          }}
        >
          Checkout
        </Button>
      )}
    </Box>
  );
}

export default MyComponent;
